import React from 'react';
import {ModalHeader, ModalBody} from 'reactstrap';
import {useTranslation} from 'react-i18next';
import {useApi} from '@/api';
import {blank} from '@/util';
import {PopError} from '@/b2b/components/Pop';
import DocumentCategory from '@/b2b/pages/Clients/DocumentCategory';
import styles from '@/b2b/index.module.css';

const AccountNoCtx = React.createContext('');

const DocumentList = ({handleClick, accountNo}) => {
  const {t: tr} = useTranslation('common');
  const [content, error] = useApi(
    `/b2b/clients/list_document?account_no=${accountNo}`,
    []
  );

  if (error) {
    return <PopError error={String(error)} />;
  }

  if (blank(content)) {
    return <PopError error={tr('documents.no_file_found')} />;
  }

  const closeBtn = (
    <span
      role='button'
      tabIndex={0}
      className={styles.modal_close}
      onClick={handleClick}
      onKeyDown={handleClick}
    >
      &times;
    </span>
  );

  return (
    <>
      <ModalHeader
        toggle={handleClick}
        close={closeBtn}
        className={styles.modal_header}
      >
        {tr('documents.title')}
      </ModalHeader>
      <ModalBody>
        <AccountNoCtx.Provider value={accountNo}>
          <ul>
            <DocumentCategory item={content} />
          </ul>
        </AccountNoCtx.Provider>
      </ModalBody>
    </>
  );
};

export default DocumentList;
export {AccountNoCtx};
